<dx-popup *ngIf="this.visible" [visible]="this.visible" title="Hedge Lookup Dialog" [showTitle]="true" [showCloseButton]="true"
          [width]="950" [height]="'72vh'" [maxWidth]="'96vw'" [resizeEnabled]="true" [closeOnOutsideClick]="false"
          [wrapperAttr]="{class: 'pha-benchmark-popup'}" (onHiding)="this.close()">
  <div *dxTemplate="let data of 'content'" class="benchmark">
    <header class="dialog-header">
    <div class="controls">
      <label>Lookback <dx-select-box [width]="160" [inputAttr]="{style: 'text-align: center'}" [items]="this.periods" displayExpr="label" valueExpr="months" [(value)]="this.months" [disabled]="this.busy"></dx-select-box></label>
      <label>Maximum Products <dx-select-box [width]="112" [inputAttr]="{style: 'text-align: center'}" [items]="this.limits" [(value)]="this.maximum" [disabled]="this.busy"></dx-select-box></label>
      <dx-button text="Calculate" type="success" [disabled]="this.busy" (onClick)="this.calculate()"></dx-button>
      <dx-button text="Cancel" [disabled]="!this.busy" (onClick)="this.cancel()"></dx-button>
    </div>
    </header>
    <section class="dialog-content">
    <div role="status" aria-live="polite" *ngIf="this.busy || this.message" class="status" [class.working]="this.busy">
      <div>{{ this.progress || this.message }}</div>
      <ng-container *ngIf="this.busy">
        <progress *ngIf="this.stage === 'history' && this.historiesTotal; else fitProgress"
                  [max]="this.historiesTotal" [value]="this.historiesCompleted" aria-label="History Checks Completed"></progress>
        <ng-template #fitProgress>
          <progress *ngIf="(this.stage === 'full-fit' || this.stage === 'validation-fit') && this.subsetsTotal; else preparing"
                    [max]="this.subsetsTotal" [value]="this.subsetsCompleted" aria-label="Candidate Mixes Checked"></progress>
        </ng-template>
        <ng-template #preparing><progress aria-label="Preparing Comparison"></progress></ng-template>
        <div *ngFor="let row of this.historyProgress" class="retry">
          <span *ngIf="row.status === 'retry-wait'">{{ row.ticker }}: retry {{ row.attempt }} / 3 in {{ row.retryInSeconds }} s</span>
        </div>
        <div class="elapsed">{{ this.elapsedSeconds | number:'1.0-0' }} s elapsed</div>
      </ng-container>
    </div>
    <dx-scroll-view class="results" direction="both" [useNative]="false">
      <ng-container *ngIf="this.report">
        <section class="recommendation" *ngIf="this.report.best">
          <h3>Best Match</h3>
          <div class="best">{{ this.mix(this.report.best) }}</div>
          <p class="run-settings">{{ this.runSettingsText }}</p>
          <p class="explanation">The best mix follows your portfolio’s daily price changes most closely.</p>
        </section>
        <h3 class="alternatives-title">Compare To Other Possible Hedges</h3>
        <ng-container *ngTemplateOutlet="fitTable; context: {$implicit: this.comparisonRows}"></ng-container>
      </ng-container>
    </dx-scroll-view>
    </section>
    <footer class="footer"><dx-button text="Close" (onClick)="this.close()"></dx-button></footer>
  </div>
</dx-popup>
<ng-template #fitTable let-rows>
  <table class="fit"><thead><tr><th>Mix</th><th>Correlation</th><th>% Protected</th><th>Avg. Daily Variation</th></tr></thead>
    <tbody>
      <tr *ngIf="this.report.best as winner" class="winner-row">
        <td><span class="winner-dot" role="img" aria-label="Winner" title="Winner"></span>{{ this.mix(winner) }}</td>
        <ng-container *ngTemplateOutlet="fitMetrics; context: {$implicit: winner}"></ng-container>
      </tr>
      <tr *ngFor="let row of rows"><td>{{ this.mix(row) }}</td>
        <ng-container *ngTemplateOutlet="fitMetrics; context: {$implicit: row}"></ng-container>
      </tr>
      <tr *ngIf="!this.winnerIsSpx"><td>SPX (100%)</td>
        <ng-container *ngIf="this.spxBenchmark as benchmark; else benchmarkUnavailable">
          <ng-container *ngTemplateOutlet="fitMetrics; context: {$implicit: benchmark}"></ng-container>
        </ng-container>
        <ng-template #benchmarkUnavailable><td colspan="3">{{ this.spxBenchmarkMessage }}</td></ng-template>
      </tr>
    </tbody>
  </table>
</ng-template>
<ng-template #fitMetrics let-fit>
  <td>{{ fit.correlation === null ? '—' : (fit.correlation | percent:'1.2-2') }}</td>
  <td>{{ fit.scale | percent:'1.2-2' }}</td><td>{{ fit.residual | percent:'1.3-3' }}</td>
</ng-template>
